const contentfulLoader = ({
  src,
  quality,
}: {
  src: string;
  quality?: number;
}) => {
  const cleanSrc = src.startsWith("//") ? `https:${src}` : src;
  return `${cleanSrc}?q=${quality || 75}`;
};

// export default function ContentfulImage({
//   src,
//   alt = "Contentful image",
//   className = "",
//   quality = 75,
// }: {
//   src: string;
//   alt?: string;
//   className?: string;
//   quality?: number;
// }) {
//   const imageUrl = contentfulLoader({ src, quality });

//   return (
//     <div className="relative overflow-hidden">
//       <img src={imageUrl} alt={alt} className={className} loading="lazy" />
//     </div>
//   );
// }

// import React from 'react'

const Avatar = ({
  src = "",
  name = "",
  alt = "user-avatar",
  className = "",
  quality = 75,
}) => {
  const imageUrl = contentfulLoader({ src, quality });
  return (
    <div className="">
      {src ? (
        <div className="relative overflow-hidden">
          <img src={imageUrl} alt={alt} className={className} loading="lazy" />
        </div>
      ) : (
        <div
          className={`rounded-full lg:text-lg font-semibold uppercase size-9 bg-gray-900 text-white flex items-center justify-center ${className}`}
        >
          {name.slice(0, 2)}
        </div>
      )}
    </div>
  );
};

export default Avatar;
